/**
 * Prefix used for gateway config overrides in URL parameters.
 */ const GATEWAY_CONFIG_URL_PARAM_PREFIX = 'gc.';
/**
 * Parses the URL for gateway config overrides
 * ?gc.<configName>=<configValue>&gc.<configName2>=<configValue2>
 */ function getURLParamsGatewayConfigOverrides(search) {
    const urlParams = new URLSearchParams(search);
    const overrides = {};
    for (const [key, value] of urlParams.entries()){
        if (key.startsWith(GATEWAY_CONFIG_URL_PARAM_PREFIX)) {
            const configName = key.slice(3); // remove the 'gc.' prefix
            try {
                // Try to parse the value as JSON
                overrides[configName] = JSON.parse(value);
            } catch (e) {
                // If it fails, use the raw value
                overrides[configName] = value;
            }
        }
    }
    return overrides;
}
/**
 * Overrides real gateway config state with states set in gateway-configs.json which are then injected via an environment variable
 * (only used in local dev).
 */ function getGatewayConfigOverridesFromEnv() {
    try {
        if (process.env.NODE_ENV !== 'development') {
            return {};
        }
        if (process.env.SKIP_GATEWAY_CONFIG_OVERRIDES === 'true') {
            return {};
        }
        const configStr = process.env.GATEWAY_CONFIG_OVERRIDES;
        return configStr === undefined ? {} : configStr;
    } catch (e) {
        // Check if gateway config overrides are valid JSON
        console.error('Error parsing gateway config override values', e);
        return {};
    }
}

export { GATEWAY_CONFIG_URL_PARAM_PREFIX, getGatewayConfigOverridesFromEnv, getURLParamsGatewayConfigOverrides };
//# sourceMappingURL=gateway-config-overrides.js.map
